import "./ConventionFormLayout.scss";

export default {
  root: "im-convention-form-layout",
  sidebarWrapper: "im-convention-form-layout__sidebar-wrapper",
  formWrapper: "im-convention-form-layout__form-wrapper",
};
